import React from "react";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaLinkedinIn,
  FaArrowRight,
  FaAward,
  FaStar,
  FaUserTie,
  FaQuoteLeft,
} from "react-icons/fa";

import principalImage from "./profileimage.png";
import vicePrincipalImage from "./profileimage.png";
import deanImage from "./profileimage.png";

const schoolLeadershipTeam = [
  {
    image: principalImage,
    name: "kdkd jfkd mf",
    role: "Principal",
    number: "01",
    description:
      "Dedicated to providing visionary leadership, promoting academic excellence, and creating a supportive learning environment where every student is encouraged to reach their full potential.",
    email: "principal@messiahmission.edu",
    phone: "+231 XXX XXX XXX",
    initials: "CF",
  },
  {
    image: vicePrincipalImage,
    name: "kfhghf jhkfhkgk ",
    role: "Vice Principal",
    number: "02",
    description:
      "Committed to strengthening academic programs, empowering teachers, and supporting students through effective administration, collaboration, and quality educational guidance.",
    email: "bondosamuel97@gmail.com",
    phone: "+231 XXX XXX XXX",
    initials: "SG",
  },
  {
    image: deanImage,
    name: "kvnfkn kkfjdbk",
    role: "Dean of Students",
    number: "03",
    description:
      "Focused on student welfare, positive discipline, character development, and leadership, fostering a respectful school community where every learner feels supported.",
    email: "andrewmakor6@gmail.com",
    phone: "+231 XXX XXX XXX",
    initials: "AM",
  },
];

const StaffPage = () => {
  const styles = `
    .jana-leadership {
      --jl-purple: #54218f;
      --jl-deep: #35105f;
      --jl-gold: #f4c542;
      --jl-gold-dark: #d6a817;
      --jl-text: #29233a;
      --jl-muted: #777184;
      position: relative;
      isolation: isolate;
      overflow: hidden;
      padding: 100px 6%;
      background:
        radial-gradient(ellipse at 0% 0%, rgba(84, 33, 143, 0.06), transparent 36%),
        linear-gradient(180deg, #ffffff 0%, #faf7ff 100%);
      font-family: inherit;
    }

    .jana-leadership *,
    .jana-leadership *::before,
    .jana-leadership *::after {
      box-sizing: border-box;
    }

    .jana-leadership::before {
      content: "";
      position: absolute;
      z-index: -1;
      top: -135px;
      right: -100px;
      width: 340px;
      height: 340px;
      border: 55px solid rgba(84, 33, 143, 0.045);
      border-radius: 50%;
      pointer-events: none;
    }

    .jana-leadership::after {
      content: "";
      position: absolute;
      z-index: -1;
      bottom: -100px;
      left: -70px;
      width: 230px;
      height: 230px;
      border-radius: 50%;
      background: rgba(244, 197, 66, 0.12);
      pointer-events: none;
    }

    .jana-leadership-header {
      max-width: 790px;
      margin: 0 auto 58px;
      text-align: center;
    }

    .jana-leadership-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 9px;
      padding: 10px 17px;
      border: 1px solid rgba(84, 33, 143, 0.13);
      border-radius: 50px;
      background: #f1e9fc;
      color: var(--jl-purple);
      font-size: 11px;
      font-weight: 850;
      letter-spacing: 1.7px;
      text-transform: uppercase;
    }

    .jana-leadership-badge svg {
      color: #b68a15;
      font-size: 14px;
    }

    .jana-leadership-title {
      margin: 23px 0 18px;
      color: var(--jl-deep);
      font-size: clamp(33px, 4.4vw, 51px);
      font-weight: 850;
      line-height: 1.15;
      letter-spacing: -1.6px;
    }

    .jana-leadership-title span {
      display: block;
      margin-top: 7px;
      color: var(--jl-purple);
    }

    .jana-leadership-description {
      max-width: 660px;
      margin: 0 auto;
      color: var(--jl-muted);
      font-size: 14px;
      line-height: 1.95;
    }

    .jana-leadership-accent {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 7px;
      margin-top: 24px;
    }

    .jana-leadership-accent span {
      height: 4px;
      border-radius: 10px;
      background: var(--jl-gold);
    }

    .jana-leadership-accent span:first-child,
    .jana-leadership-accent span:last-child {
      width: 25px;
      opacity: 0.65;
    }

    .jana-leadership-accent span:nth-child(2) {
      width: 53px;
      background: var(--jl-purple);
    }

    .jana-leadership-grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      align-items: stretch;
      gap: 26px;
      max-width: 1240px;
      margin: 0 auto;
    }

    .jana-leader-card {
      position: relative;
      display: flex;
      flex-direction: column;
      min-width: 0;
      overflow: hidden;
      border: 1px solid #eee7f5;
      border-radius: 23px;
      background: #ffffff;
      box-shadow: 0 12px 38px rgba(53, 16, 95, 0.065);
      transition:
        transform 0.3s ease,
        box-shadow 0.3s ease,
        border-color 0.3s ease;
    }

    .jana-leader-card:hover {
      transform: translateY(-8px);
      border-color: rgba(84, 33, 143, 0.25);
      box-shadow: 0 23px 48px rgba(53, 16, 95, 0.14);
    }

    .jana-leader-image-area {
      position: relative;
      height: 300px;
      overflow: hidden;
      background: linear-gradient(145deg, #eee4fa, #d9c6f0);
    }

    .jana-leader-image-area::after {
      content: "";
      position: absolute;
      inset: 45% 0 0;
      background: linear-gradient(
        to bottom,
        transparent,
        rgba(35, 9, 62, 0.5)
      );
      pointer-events: none;
    }

    .jana-leader-image {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center top;
      transition: transform 0.55s ease;
    }

    .jana-leader-card:hover .jana-leader-image {
      transform: scale(1.055);
    }

    .jana-leader-image-number {
      position: absolute;
      z-index: 1;
      top: 17px;
      left: 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 43px;
      height: 34px;
      padding: 0 10px;
      border: 1px solid rgba(255, 255, 255, 0.45);
      border-radius: 9px;
      background: rgba(53, 16, 95, 0.85);
      color: var(--jl-gold);
      font-size: 12px;
      font-weight: 850;
      backdrop-filter: blur(8px);
    }

    .jana-leader-role {
      position: absolute;
      z-index: 2;
      right: 17px;
      bottom: 17px;
      left: 17px;
      display: flex;
      align-items: center;
      gap: 9px;
      width: fit-content;
      max-width: calc(100% - 34px);
      padding: 10px 14px;
      border: 1px solid rgba(255, 255, 255, 0.35);
      border-radius: 9px;
      background: var(--jl-gold);
      color: var(--jl-deep);
      font-size: 11px;
      font-weight: 850;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    }

    .jana-leader-role svg {
      flex-shrink: 0;
      font-size: 13px;
    }

    .jana-leader-content {
      display: flex;
      flex: 1;
      flex-direction: column;
      padding: 25px 25px 23px;
    }

    .jana-leader-eyebrow {
      margin-bottom: 8px;
      color: #a27b18;
      font-size: 10px;
      font-weight: 850;
      letter-spacing: 1.6px;
      text-transform: uppercase;
    }

    .jana-leader-name {
      margin: 0;
      color: var(--jl-deep);
      font-size: 21px;
      font-weight: 850;
      line-height: 1.4;
      letter-spacing: -0.45px;
      overflow-wrap: anywhere;
    }

    .jana-leader-position {
      margin: 5px 0 0;
      color: var(--jl-purple);
      font-size: 12px;
      font-weight: 750;
    }

    .jana-leader-quote {
      display: flex;
      gap: 11px;
      margin: 20px 0;
      padding: 16px 14px;
      border-left: 3px solid var(--jl-gold);
      border-radius: 0 10px 10px 0;
      background: #faf7ff;
    }

    .jana-leader-quote-icon {
      flex-shrink: 0;
      margin-top: 3px;
      color: #c09a32;
      font-size: 14px;
    }

    .jana-leader-text {
      margin: 0;
      color: #696276;
      font-size: 12.5px;
      line-height: 1.85;
    }

    .jana-leader-contact-label {
      margin: auto 0 12px;
      padding-top: 17px;
      color: #8a8295;
      font-size: 10px;
      font-weight: 850;
      letter-spacing: 1.3px;
      text-transform: uppercase;
    }

    .jana-leader-contact {
      display: flex;
      align-items: center;
      gap: 10px;
      padding-top: 14px;
      border-top: 1px solid #f0eaf6;
    }

    .jana-leader-contact-link {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      flex-shrink: 0;
      border: 1px solid #eae1f4;
      border-radius: 12px;
      background: #f7f2fd;
      color: var(--jl-purple);
      font-size: 15px;
      text-decoration: none;
      transition:
        color 0.25s ease,
        background 0.25s ease,
        border-color 0.25s ease,
        transform 0.25s ease;
    }

    .jana-leader-contact-link:hover {
      transform: translateY(-2px);
      border-color: var(--jl-purple);
      background: var(--jl-purple);
      color: var(--jl-gold);
    }

    .jana-leader-contact-link:focus-visible,
    .jana-leadership-contact-cta:focus-visible {
      outline: 3px solid var(--jl-gold-dark);
      outline-offset: 3px;
    }

    .jana-leadership-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 24px;
      max-width: 1240px;
      margin: 38px auto 0;
      padding: 27px 30px;
      border-radius: 18px;
      background: linear-gradient(115deg, #35105f, #54218f);
      box-shadow: 0 15px 35px rgba(53, 16, 95, 0.15);
    }

    .jana-leadership-footer-copy {
      display: flex;
      align-items: center;
      gap: 17px;
      min-width: 0;
    }

    .jana-leadership-footer-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 49px;
      height: 49px;
      flex-shrink: 0;
      border-radius: 15px;
      background: rgba(244, 197, 66, 0.15);
      color: var(--jl-gold);
      font-size: 22px;
    }

    .jana-leadership-footer-copy h3 {
      margin: 0 0 6px;
      color: #ffffff;
      font-size: 16px;
      font-weight: 850;
    }

    .jana-leadership-footer-copy p {
      margin: 0;
      color: rgba(255, 255, 255, 0.76);
      font-size: 12.5px;
      line-height: 1.75;
    }

    .jana-leadership-contact-cta {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      min-height: 46px;
      padding: 0 19px;
      flex-shrink: 0;
      border-radius: 10px;
      background: var(--jl-gold);
      color: var(--jl-deep);
      font-size: 12px;
      font-weight: 850;
      text-decoration: none;
      transition:
        background 0.25s ease,
        transform 0.25s ease;
    }

    .jana-leadership-contact-cta:hover {
      transform: translateY(-2px);
      background: #ffdc72;
      color: var(--jl-deep);
    }

    @media (max-width: 1050px) {
      .jana-leadership {
        padding: 80px 5%;
      }

      .jana-leadership-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 22px;
      }

      .jana-leader-card:last-child {
        grid-column: 1 / -1;
      }

      .jana-leader-card:last-child .jana-leader-image-area {
        height: 340px;
      }
    }

    @media (max-width: 650px) {
      .jana-leadership {
        padding: 65px 5%;
      }

      .jana-leadership-header {
        margin-bottom: 37px;
      }

      .jana-leadership-title {
        font-size: 33px;
        letter-spacing: -1px;
      }

      .jana-leadership-description {
        font-size: 13.5px;
      }

      .jana-leadership-grid {
        grid-template-columns: minmax(0, 1fr);
        gap: 20px;
      }

      .jana-leader-card:last-child {
        grid-column: auto;
      }

      .jana-leader-image-area,
      .jana-leader-card:last-child .jana-leader-image-area {
        height: 310px;
      }

      .jana-leader-content {
        padding: 23px 21px;
      }

      .jana-leadership-footer {
        align-items: stretch;
        flex-direction: column;
        padding: 24px 21px;
      }

      .jana-leadership-contact-cta {
        width: 100%;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .jana-leader-card,
      .jana-leader-image,
      .jana-leader-contact-link,
      .jana-leadership-contact-cta {
        transition: none !important;
      }
    }
  `;

  return (
    <>
      <style>{styles}</style>

      <section
        className="jana-leadership"
        aria-labelledby="jana-leadership-heading"
      >
        <header className="jana-leadership-header">
          <span className="jana-leadership-badge">
            <FaStar aria-hidden="true" />
            School Leadership
          </span>

          <h2
            className="jana-leadership-title"
            id="jana-leadership-heading"
          >
            Meet the People Behind
            <span>Our Educational Excellence</span>
          </h2>

          <p className="jana-leadership-description">
            Strong leadership builds strong schools. Meet our
            dedicated administrators, committed to academic
            achievement, student development, integrity, and a
            welcoming environment where every learner can thrive.
          </p>

          <div
            className="jana-leadership-accent"
            aria-hidden="true"
          >
            <span />
            <span />
            <span />
          </div>
        </header>

        <div className="jana-leadership-grid">
          {schoolLeadershipTeam.map((leader) => (
            <article className="jana-leader-card" key={leader.name}>
              <div className="jana-leader-image-area">
                <img
                  src={leader.image}
                  alt={`${leader.name}, ${leader.role}`}
                  className="jana-leader-image"
                  loading="lazy"
                  onError={(event) => {
                    event.currentTarget.style.visibility = "hidden";
                  }}
                />

                <span className="jana-leader-image-number">
                  {leader.number}
                </span>

                <span className="jana-leader-role">
                  <FaAward aria-hidden="true" />
                  {leader.role}
                </span>
              </div>

              <div className="jana-leader-content">
                <span className="jana-leader-eyebrow">
                  Our Leadership Team
                </span>

                <h3 className="jana-leader-name">{leader.name}</h3>

                <p className="jana-leader-position">{leader.role}</p>

                <div className="jana-leader-quote">
                  <FaQuoteLeft
                    className="jana-leader-quote-icon"
                    aria-hidden="true"
                  />

                  <p className="jana-leader-text">
                    {leader.description}
                  </p>
                </div>

                <p className="jana-leader-contact-label">
                  Connect with {leader.name.split(" ")[1] || "our team"}
                </p>

                <div className="jana-leader-contact">
                  <a
                    className="jana-leader-contact-link"
                    href={`mailto:${leader.email}`}
                    aria-label={`Email ${leader.name}`}
                    title={`Email ${leader.name}`}
                  >
                    <FaEnvelope aria-hidden="true" />
                  </a>

                  {leader.phone.includes("X") ? (
                    <span
                      className="jana-leader-contact-link"
                      aria-label="Phone number not yet provided"
                      title="Phone number not yet provided"
                      style={{ opacity: 0.45, cursor: "not-allowed" }}
                    >
                      <FaPhoneAlt aria-hidden="true" />
                    </span>
                  ) : (
                    <a
                      className="jana-leader-contact-link"
                      href={`tel:${leader.phone.replace(/[^\d+]/g, "")}`}
                      aria-label={`Call ${leader.name}`}
                      title={`Call ${leader.name}`}
                    >
                      <FaPhoneAlt aria-hidden="true" />
                    </a>
                  )}

                  <span
                    className="jana-leader-contact-link"
                    aria-label="LinkedIn profile not provided"
                    title="LinkedIn profile not provided"
                    style={{ opacity: 0.45, cursor: "not-allowed" }}
                  >
                    <FaLinkedinIn aria-hidden="true" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="jana-leadership-footer">
          <div className="jana-leadership-footer-copy">
            <div className="jana-leadership-footer-icon">
              <FaUserTie aria-hidden="true" />
            </div>

            <div>
              <h3>Leadership with Purpose. Education with Excellence.</h3>
              <p>
                Together, we are building a supportive school community
                and preparing students for a brighter future.
              </p>
            </div>
          </div>

          <a
            className="jana-leadership-contact-cta"
            href="mailto:principal@messiahmission.edu"
          >
            Contact School Administration
            <FaArrowRight aria-hidden="true" />
          </a>
        </div>
      </section>
    </>
  );
};

export default StaffPage;
